import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ListViewMode } from '../../user/user.store';
import { DeleteProjectConfirmationModal } from './DeleteProjectConfirmationModal';
import { IProjectsListTableProps, ProjectsListTable } from './ProjectsListTable';
import { IProjectsListThumbsProps, ProjectsListThumbs } from './ProjectsListThumbs';

interface IProjectsListProps extends IProjectsListTableProps, IProjectsListThumbsProps {
  projectsListViewMode: ListViewMode;
  showDeleteModal: boolean;
  projectDatasetsToDelete: string[];
  onDeleteConfirmed: (deleteDatasets: boolean) => Promise<void>;
  onDeleteCanceled: () => void;
  isLoading: boolean;
}

export const ProjectsList = observer((props: IProjectsListProps): ReactElement => {
  return (
    <>
      {props.projectsListViewMode === ListViewMode.List ? (
        <ProjectsListTable
          isLoading={props.isLoading}
          workspaceId={props.workspaceId}
          projects={props.projects}
          pagination={props.pagination}
          sorting={props.sorting}
          onDelete={props.onDelete}
          onAnnotate={props.onAnnotate}
          onReview={props.onReview}
          onOrderingChange={props.onOrderingChange}
          onGoToClarifications={props.onGoToClarifications}
        />
      ) : (
        <ProjectsListThumbs
          isLoading={props.isLoading}
          projects={props.projects}
          projectsListViewMode={props.projectsListViewMode}
          onDelete={props.onDelete}
          workspaceId={props.workspaceId}
          onGoToClarifications={props.onGoToClarifications}
          pagination={props.pagination}
        />
      )}
      <DeleteProjectConfirmationModal
        onCancel={props.onDeleteCanceled}
        onConfirm={props.onDeleteConfirmed}
        showModal={props.showDeleteModal}
        projectDatasetsToDelete={props.projectDatasetsToDelete}
      />
    </>
  );
});
